import { get } from '../../../utils/api';

export default {
  getFooterLinks: () => get({ url: 'link/list' }),
};
